import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f1628d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-18" }, null, -1))
const _hoisted_3 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col-xs-12 ant-col-xl-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Desconto", -1))
const _hoisted_7 = { class: "ant-col-xs-12 ant-col-xl-5" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Outras Taxas", -1))
const _hoisted_9 = { class: "ant-col-xs-12 ant-col-xl-5" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Valor Mínimo", -1))
const _hoisted_11 = { class: "ant-col-xs-12 ant-col-xl-5" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Valor Máximo", -1))
const _hoisted_13 = { class: "ant-col-xs-12 ant-col-xl-5" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Valor Mínimo Parcela", -1))
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col-xs-24 ant-col-xl-24" }
const _hoisted_17 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_18 = { class: "ant-col-xs-24 ant-col-xl-18" }
const _hoisted_19 = { class: "ant-col-xs-24 ant-col-xl-6" }
const _hoisted_20 = { class: "ant-row" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  role: "img",
  "aria-label": "close",
  class: "anticon anticon-close"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    focusable: "false",
    class: "",
    "data-icon": "close",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "64 64 896 896"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" })
  ])
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["value"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "ant-col-xs-12 ant-col-xl-4" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "ant-row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-18 ant-col-xl-18" }, null, -1))
const _hoisted_30 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_31 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_card = _resolveComponent("card")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_selecionar_status_titulo_financeiro = _resolveComponent("selecionar-status-titulo-financeiro")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_selecionar_tipo_documento_financeiro_modal = _resolveComponent("selecionar-tipo-documento-financeiro-modal")!
  const _component_forma_pagamento_copiar_tipo_documento_financeiro = _resolveComponent("forma-pagamento-copiar-tipo-documento-financeiro")!
  const _component_forma_pagamento_parcelas_modal = _resolveComponent("forma-pagamento-parcelas-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_card, { titulo: "DEFINIÇÕES POR TIPO DE DOCUMENTO" }, {
          default: _withCtx(() => [
            (_ctx.computedTiposPagamento.length === 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum tipo de documento adicionado ainda." }),
                  _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("button", {
                        class: "ant-btn ant-btn-secondary ss-botao-secundario",
                        style: {"width":"100%"},
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.abrirAdicionarTipoDocumento && _ctx.abrirAdicionarTipoDocumento(...args)))
                      }, "Adicionar Tipo de Documento")
                    ])
                  ])
                ], 64))
              : (_openBlock(), _createBlock(_component_a_spin, {
                  key: 1,
                  spinning: _ctx.state.carregando
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tabs, {
                      defaultActiveKey: "1",
                      type: "editable-card",
                      onEdit: _ctx.editarTiposDocumento
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedTiposPagamento, (tipoDocumentoFinanceiro, index) => {
                          return (_openBlock(), _createBlock(_component_a_tab_pane, {
                            style: {"padding-top":"5px"},
                            tab: tipoDocumentoFinanceiro.descricaoTipoDocumentoFinanceiro,
                            key: index
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_card, { titulo: "DEFINIÇÕES E TAXAS" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                      _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                                        label: _withCtx(() => [
                                          _hoisted_6,
                                          _createVNode(_component_a_tooltip, {
                                            placement: "top",
                                            title: "% de desconto máxima quando o pagamento for feito em um único tipo de documento"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_icone, {
                                                class: "ss-icone-informacao-campo",
                                                nome: "informacao-campo"
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_campo_numerico, {
                                            percentual: true,
                                            quantidadeCasasDecimais: 2,
                                            valor: _ctx.computedTiposPagamento[index].desconto,
                                            "onUpdate:valor": ($event: any) => ((_ctx.computedTiposPagamento[index].desconto) = $event)
                                          }, null, 8, ["valor", "onUpdate:valor"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _createElementVNode("div", _hoisted_7, [
                                      _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                                        label: _withCtx(() => [
                                          _hoisted_8,
                                          _createVNode(_component_a_tooltip, {
                                            placement: "top",
                                            title: "Valor de taxas por parcela lançada"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_icone, {
                                                class: "ss-icone-informacao-campo",
                                                nome: "informacao-campo"
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_campo_numerico, {
                                            monetario: true,
                                            quantidadeCasasDecimais: 2,
                                            valor: _ctx.computedTiposPagamento[index].outrasTaxas,
                                            "onUpdate:valor": ($event: any) => ((_ctx.computedTiposPagamento[index].outrasTaxas) = $event)
                                          }, null, 8, ["valor", "onUpdate:valor"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                      _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                                        label: _withCtx(() => [
                                          _hoisted_10,
                                          _createVNode(_component_a_tooltip, {
                                            placement: "top",
                                            title: "Valor mínimo de lançamento total para usar esse tipo de documento"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_icone, {
                                                class: "ss-icone-informacao-campo",
                                                nome: "informacao-campo"
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_campo_numerico, {
                                            monetario: true,
                                            quantidadeCasasDecimais: 2,
                                            valor: _ctx.computedTiposPagamento[index].valorMinimo,
                                            "onUpdate:valor": ($event: any) => ((_ctx.computedTiposPagamento[index].valorMinimo) = $event)
                                          }, null, 8, ["valor", "onUpdate:valor"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _createElementVNode("div", _hoisted_11, [
                                      _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                                        label: _withCtx(() => [
                                          _hoisted_12,
                                          _createVNode(_component_a_tooltip, {
                                            placement: "top",
                                            title: "Valor máximo de lançamento total para usar esse tipo de documento"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_icone, {
                                                class: "ss-icone-informacao-campo",
                                                nome: "informacao-campo"
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_campo_numerico, {
                                            monetario: true,
                                            quantidadeCasasDecimais: 2,
                                            valor: _ctx.computedTiposPagamento[index].valorMaximo,
                                            "onUpdate:valor": ($event: any) => ((_ctx.computedTiposPagamento[index].valorMaximo) = $event)
                                          }, null, 8, ["valor", "onUpdate:valor"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _createElementVNode("div", _hoisted_13, [
                                      _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                                        label: _withCtx(() => [
                                          _hoisted_14,
                                          _createVNode(_component_a_tooltip, {
                                            placement: "top",
                                            title: "Valor mínimo por parcela"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_icone, {
                                                class: "ss-icone-informacao-campo",
                                                nome: "informacao-campo"
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_campo_numerico, {
                                            monetario: true,
                                            quantidadeCasasDecimais: 2,
                                            valor: _ctx.computedTiposPagamento[index].valorMinParcela,
                                            "onUpdate:valor": ($event: any) => ((_ctx.computedTiposPagamento[index].valorMinParcela) = $event)
                                          }, null, 8, ["valor", "onUpdate:valor"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Categoria Padrão",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_selecionar_categoria_plano_conta, {
                                            empresas: [_ctx.props.empresa],
                                            codigoSelecionado: _ctx.computedTiposPagamento[index].codigoPlanoContaCategoriaPadrao,
                                            "onUpdate:codigoSelecionado": ($event: any) => ((_ctx.computedTiposPagamento[index].codigoPlanoContaCategoriaPadrao) = $event)
                                          }, null, 8, ["empresas", "codigoSelecionado", "onUpdate:codigoSelecionado"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_card, { titulo: "MOVIMENTO DE CAIXA" }, {
                                AcoesExtra: _withCtx(() => [
                                  _createVNode(_component_a_switch, {
                                    checked: _ctx.computedTiposPagamento[index].gerarCaixaDiario,
                                    "onUpdate:checked": ($event: any) => ((_ctx.computedTiposPagamento[index].gerarCaixaDiario) = $event),
                                    style: {"float":"right"},
                                    "checked-children": "Lançar",
                                    "un-checked-children": "Não Lançar",
                                    onChange: ($event: any) => (_ctx.alterarCaixa(index))
                                  }, null, 8, ["checked", "onUpdate:checked", "onChange"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_card, {
                                titulo: 'LANÇAMENTO NO CONTAS A ' + (_ctx.props.tipoOperacao === _ctx.ETipoOperacao.Entrada ? 'PAGAR': 'RECEBER')
                              }, {
                                AcoesExtra: _withCtx(() => [
                                  _createVNode(_component_a_switch, {
                                    checked: _ctx.computedTiposPagamento[index].gerarCarteira,
                                    "onUpdate:checked": ($event: any) => ((_ctx.computedTiposPagamento[index].gerarCarteira) = $event),
                                    style: {"float":"right"},
                                    "checked-children": "Lançar",
                                    "un-checked-children": "Não Lançar",
                                    onChange: ($event: any) => (_ctx.alterarCarteira(index))
                                  }, null, 8, ["checked", "onUpdate:checked", "onChange"])
                                ]),
                                default: _withCtx(() => [
                                  (_ctx.computedTiposPagamento[index].gerarCarteira)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        _createElementVNode("div", _hoisted_18, [
                                          _createVNode(_component_selecionar_conta, {
                                            empresas: [_ctx.props.empresa],
                                            codigoSelecionado: _ctx.computedTiposPagamento[index].codigoConta,
                                            "onUpdate:codigoSelecionado": ($event: any) => ((_ctx.computedTiposPagamento[index].codigoConta) = $event)
                                          }, null, 8, ["empresas", "codigoSelecionado", "onUpdate:codigoSelecionado"])
                                        ]),
                                        _createElementVNode("div", _hoisted_19, [
                                          _createVNode(_component_a_form_item, {
                                            label: "Status do Título",
                                            class: "ss-margin-campos"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_selecionar_status_titulo_financeiro, {
                                                apenasPendenteBaixado: true,
                                                valor: _ctx.computedTiposPagamento[index].statusCarteiras,
                                                "onUpdate:valor": ($event: any) => ((_ctx.computedTiposPagamento[index].statusCarteiras) = $event)
                                              }, null, 8, ["valor", "onUpdate:valor"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["titulo"]),
                              (_ctx.computedTiposPagamento[index].gerarCarteira)
                                ? (_openBlock(), _createBlock(_component_card, {
                                    key: 0,
                                    titulo: "PARCELAMENTOS"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_20, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedTiposPagamento[index].parcelamentos, (parcelamento, indexParcelamento) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: indexParcelamento,
                                            class: "ant-col-xs-12 ant-col-xl-4"
                                          }, [
                                            _createVNode(_component_card, {
                                              titulo: (indexParcelamento + 1) == 1? '1 Parcela' : (indexParcelamento + 1) + ' Parcelas',
                                              class: "ss-card-parcela"
                                            }, {
                                              AcoesExtra: _withCtx(() => [
                                                _createElementVNode("button", {
                                                  style: {"float":"right"},
                                                  type: "button",
                                                  "aria-label": "remove",
                                                  tabindex: "0",
                                                  class: "ant-tabs-tab-remove",
                                                  onClick: ($event: any) => (_ctx.removerParcelamento(index, indexParcelamento))
                                                }, _hoisted_23, 8, _hoisted_21)
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_form_item, {
                                                  label: "Taxa Mês",
                                                  class: "ss-margin-campos"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_campo_numerico, {
                                                      percentual: true,
                                                      quantidadeCasasDecimais: 2,
                                                      valor: _ctx.computedTiposPagamento[index].parcelamentos[indexParcelamento].taxa,
                                                      "onUpdate:valor": ($event: any) => ((_ctx.computedTiposPagamento[index].parcelamentos[indexParcelamento].taxa) = $event)
                                                    }, null, 8, ["valor", "onUpdate:valor"])
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_a_form_item, {
                                                  label: "Prazo Total",
                                                  class: "ss-margin-campos"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("input", {
                                                      class: "ant-input",
                                                      type: "number",
                                                      min: "0",
                                                      style: {"text-align":"right"},
                                                      value: _ctx.computedTiposPagamento[index].parcelamentos[indexParcelamento].prazoTotal === 0 ? 'Livre' : _ctx.computedTiposPagamento[index].parcelamentos[indexParcelamento].prazoTotal,
                                                      disabled: ""
                                                    }, null, 8, _hoisted_24)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createElementVNode("button", {
                                                  class: "ant-btn ant-btn-secondary ss-botao-secundario",
                                                  style: {"margin-top":"3px","width":"100%"},
                                                  onClick: ($event: any) => (_ctx.abrirParcelamento(index, indexParcelamento))
                                                }, "Detalhar", 8, _hoisted_25)
                                              ]),
                                              _: 2
                                            }, 1032, ["titulo"])
                                          ]))
                                        }), 128)),
                                        _createElementVNode("div", _hoisted_26, [
                                          _createVNode(_component_card, {
                                            class: "ss-card-parcelamento",
                                            style: {"height":"176px","padding":"0px"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("button", {
                                                class: "ant-btn ant-btn-ghost ss-adicionar-parcelamento",
                                                onClick: ($event: any) => (_ctx.adicionarParcelamento(index))
                                              }, [
                                                _createVNode(_component_icone, {
                                                  nome: "novo",
                                                  style: {"font-size":"40px","margin-top":"20px"}
                                                })
                                              ], 8, _hoisted_27)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_28, [
                                _hoisted_29,
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("button", {
                                    class: "ant-btn ant-btn-secondary ss-botao-secundario",
                                    style: {"width":"100%"},
                                    onClick: ($event: any) => (_ctx.abrirCopiarTipoDocumento(index))
                                  }, "Copiar Tipo de Documento", 8, _hoisted_31)
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["tab"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["onEdit"])
                  ]),
                  _: 1
                }, 8, ["spinning"]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_selecionar_tipo_documento_financeiro_modal, {
      empresas: [_ctx.props.empresa],
      visivel: _ctx.state.exibirSelecaoTipoDocumento,
      "onUpdate:visivel": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.exibirSelecaoTipoDocumento) = $event)),
      onConfirmar: _ctx.adicionarTipoDocumento
    }, null, 8, ["empresas", "visivel", "onConfirmar"]),
    _createVNode(_component_forma_pagamento_copiar_tipo_documento_financeiro, {
      empresa: _ctx.props.empresa,
      "tipo-documento-financeiro": _ctx.state.tipoDocumentoSelecionado,
      visivel: _ctx.state.exibirCopiarTipoDocumento,
      "onUpdate:visivel": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.exibirCopiarTipoDocumento) = $event)),
      onConfirmar: _ctx.adicioanrVariosTiposDocumentos
    }, null, 8, ["empresa", "tipo-documento-financeiro", "visivel", "onConfirmar"]),
    _createVNode(_component_forma_pagamento_parcelas_modal, {
      parcelamento: _ctx.state.parcelamentoSelecionado,
      visivel: _ctx.state.exibirParcelas,
      "onUpdate:visivel": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.exibirParcelas) = $event)),
      onClick: _ctx.atualizarParcelamento
    }, null, 8, ["parcelamento", "visivel", "onClick"])
  ], 64))
}